import logo from './logoimg.png';
import logotext from './logotext.png';
import whitelogo from './whitelogoimg.png';
import whitelogotext from './whitelogotext.png';
import banner1 from './banner1.png';
import banner2 from './banner2.png';
import banner3 from './banner3.png';
import banner4 from './banner4.png';
import videocover from './videocover.png';
import ellipse1 from './ellipse1.png';
import ellipse2 from './ellipse2.png';
import ellipse3 from './ellipse3.png';
import ellipse4 from './ellipse4.png';
import video from './video.mov';
import serviceimg1 from './service1.png';
import serviceimg2 from './service2.png';
import serviceimg3 from './service3.png';
import whyusimg from './whyusimg.png';
import partnerlogo1 from './logo1.png';
import partnerlogo2 from './logo2.png';
import partnerlogo3 from './logo3.png';
import aboutbanner from './about/banner.png';
import infoimg from './about/infobanner.png';
import team1 from './about/team1.png';
import team2 from './about/team2.png';
import team3 from './about/team3.png';
import team4 from './about/team4.png';
import team5 from './about/team5.png';
import team6 from './about/team6.png';
import servicePage1 from './services1.png';
import servicePage2 from './services2.png';
import servicePage3 from './services3.png';
import servicePage4 from './service4.png';
import serviceBanner from './servicebanner.png';
import windmill from './windmill.png';


export const image={
    logo,
    logotext,
    whitelogo,
    whitelogotext,
    banner1,
    banner2,
    banner3,
    banner4,
    videocover,
    ellipse1,
    ellipse2,
    ellipse3,
    ellipse4,
    video,
    serviceimg1,
    serviceimg2,
    serviceimg3,
    whyusimg,
    partnerlogo1,
    partnerlogo2,
    partnerlogo3,
    aboutbanner,
    infoimg,
    team1,
    team2,
    team3,
    team4,
    team5,
    team6,
    servicePage1,
    servicePage2,
    servicePage3,
    serviceBanner,
    servicePage4,
    windmill,
}